import { isAfter, isValid } from 'date-fns';

export const isValidDate = (date: Date | null): boolean | null => {
  return date && isValid(date) && isAfter(date, new Date('1/1/1000'));
};
